import { cn } from "@/shared/lib/utils";

/**
 * 「旧版声纹」小徽标(1006):声纹 `supportsTuning === false`(cosyvoice 时代录的)时挂在
 * 声纹卡/下拉项旁 —— 方言、多语言与演绎方式对它不生效,重新录一次即可解锁。
 * 判据统一走 `voiceProfileSupportsTuning`(缺省按支持,不误标)。
 */
export function LegacyVoiceBadge({ className }: { className?: string }) {
  return (
    <span
      data-testid="voice-legacy-badge"
      className={cn(
        "inline-flex shrink-0 items-center rounded border border-border/70 px-1 text-[10px] font-normal leading-4 text-muted-foreground",
        className
      )}
    >
      旧版声纹
    </span>
  );
}
